// NPM Requirements
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';

import IsoMorphUtils from '../../modules/isoMorphUtils';

import styles from './MapListItem.module.postcss';

class MapListItem extends Component {
  render() {
    const { location, onClose } = this.props;

    if (!location) return null;

    let events = null;
    let trucks = null;

    const uniqueEvents = _.uniqBy(location.events, 'id');
    events = uniqueEvents.map((event) => {
      if (event.trucks && event.trucks.length > 0) {
        trucks = event.trucks.map((truck, truckIndex) => {
          let image = null;
          if (truck.featured_photo) {
            image = `${IsoMorphUtils.railsContext.imageBase}/${truck.featured_photo}`;
          } else {
            image = '/static/images/truck-placeholder.png';
          }
          const categories = truck.food_categories.map((c) => c.name).join(', ');

          return (
            <Link
              className={styles.MapListItem_truck}
              key={`map-list-${event.id}-${truck.id}-${truckIndex}`}
              to={`/food-trucks/${truck.id}`}
              target="_blank" rel="noopener noreferrer"
            >
              <div
                className={styles.MapListItem_truckImage}
                style={{ backgroundImage: `url("${image}")` }}
              />
              <div className={styles.MapListItem_truckText}>
                <div className={styles.MapListItem_truckName}>
                  {truck.name}
                </div>
                <span className={styles.MapListItem_truckCategories}>
                  {categories}
                </span>
              </div>
            </Link>
          );
        });
      }

      const start = moment(event.start_time).format('h:mma');
      const end = moment(event.end_time).format('h:mma');

      return (
        <div className="MapListItem-event" key={event.id}>
          <div className={styles.MapListItem_time}>
            <div className={styles.MapListItem_timeHours}>
              <span className="icon icon-clock" />
              {start} <span className="arrow">&rarr;</span> {end}
            </div>
          </div>
          {trucks &&
            <div className="MapListItem-trucks">
              {trucks}
            </div>
          }
        </div>
      );
    });

    return (
      <div className={styles.MapListItem}>
        <div className={styles.MapListItem_details}>
          <div
            className={`${styles.MapListItem_close} u-pullRight`}
            onClick={onClose}
          >
            <img src="/static/images/admin/x.svg" alt="Close Pane" />
          </div>
          <Link
            to={`/schedule/${location.slug}`}
            target="_blank" rel="noopener noreferrer"
            className={styles.MapListItem_locationHeader}
          >
            <div
              className={styles.MapListItem_locationName}
            >
              {location.name}
            </div>
            <div className={styles.MapListItem_locationAddress}>
              <span className="icon icon-pin" />
              {location.filtered_address}
            </div>
          </Link>
          <div className="MapListItem-events">
            {events}
          </div>
        </div>
      </div>
    );
  }
}

MapListItem.propTypes = {
  location: PropTypes.object,
  onClose: PropTypes.func,
};

export default MapListItem;
